import React from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { isFeatureFlag } from "../../shared/utility";

export default function DayHistoryModal({
  open,
  setOpen,
  date,
  formattedDate,
  items = [],
  loading = false,
  onRefresh,
  onView,
  analytics,
}) {
  const header = (
    <div className="flex items-center justify-between w-full">
      <div className="font-semibold">Production history — {formattedDate}</div>
      <div className="flex items-center gap-3 mr-5">
        <Button
          label="Refresh"
          className="p-button-sm"
          onClick={() => onRefresh && onRefresh()}
        />
        <Button
          label="Close"
          className="p-button-sm p-button-secondary"
          onClick={() => setOpen(false)}
        />
      </div>
    </div>
  );

  const statusBody = (rowData) => {
    if (isFeatureFlag("in_process_monitoring")) {
      var raw = (rowData.process_status_id || "unknown").toString();
    } else {
      var raw = (rowData.status || "unknown").toString();
    }

    const status = raw;
    const lower = raw.toLowerCase();
    // treat any variant of "progress" as in-progress -> gray
    if (lower.includes("progress")) {
      return <Tag value={status} className="bg-gray-600 text-white" />;
    }
    // completed -> success, others -> warning
    const severity = lower === "completed" ? "success" : "warning";
    return <Tag value={status} severity={severity} />;
  };

  const timeBody = (rowData) =>
    rowData.time || new Date(rowData.production_date).toLocaleTimeString();

  const actionsBody = (rowData) => {
    if (!rowData || !rowData.id)
      return <span className="text-sm text-gray-500">No details</span>;

    return (
      <a
        href={`/manufactured-products/${rowData.id}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Open details for ${
          rowData.product_name || rowData.id
        } in new tab`}
        className="inline-flex items-center rounded-md bg-main-purple px-3 py-1 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 whitespace-nowrap"
      >
        View details
      </a>
    );
  };

  return (
    <Dialog
      visible={open}
      onHide={() => setOpen(false)}
      style={{ width: "80vw" }}
      header={header}
      modal
      closable={false}
    >
      {loading ? (
        <div className="text-center py-10">Loading...</div>
      ) : items.length === 0 ? (
        <div className="text-center py-10 text-gray-600">
          No production runs for this date.
        </div>
      ) : (
        <div>
          {/* Improved stats header: show total manufactured weight and target weight as styled cards */}
          <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {(() => {
              const stats = analytics.stats;

              return (
                <>
                  <div className="p-4 bg-white border rounded-md shadow-sm">
                    <div className="text-sm text-gray-500">
                      Total manufactured weight
                    </div>
                    <div className="mt-1 text-2xl font-semibold text-gray-900">
                      {stats[0].stat}
                    </div>
                  </div>
                  <div className="p-4 bg-white border rounded-md shadow-sm">
                    <div className="text-sm text-gray-500">
                      Total manufactured target weight
                    </div>
                    <div className="mt-1 text-2xl font-semibold text-gray-900">
                      {stats[1].stat}
                    </div>
                  </div>
                </>
              );
            })()}
          </div>
          <DataTable
            value={items}
            responsiveLayout="scroll"
            className="p-datatable-sm"
            paginator
            rows={10}
          >
            <Column header="Time" body={timeBody} />
            <Column field="product_name" header="Product" />
            <Column field="new_lot_number" header="Lot" />
            <Column field="plu" header="PLU" />
            <Column header="Status" body={statusBody} />
            <Column
              header="Actions"
              body={actionsBody}
              style={{ width: "80px" }}
            />
          </DataTable>
        </div>
      )}
    </Dialog>
  );
}
